import { Text } from 'grommet';

// Small shared wrappers for the loading/error text the docs pages render.
// The older data views (App, LeagueCard, the scoreboards) still inline their
// own copies of this; they can adopt these as a follow-up.

export const Loading = ({ children = 'Loading…' }) => <Text>{children}</Text>;

export const ErrorText = ({ children }) => (
  <Text color="status-critical">{children}</Text>
);
